import { Order, OrderTransform } from '@ca/common'
import isEqual from 'lodash/isEqual'

// Encodes like the transport does, so `undefined` and missing, `NaN` and `null` match
const toNormalized = <T>(value: T) =>
  JSON.parse(JSON.stringify(value ?? null))

// Only a change the ERP receives may set `updated` on a patch
const isSameErpOrder = (a: Order, b: Order) =>
  isEqual(
    toNormalized(OrderTransform.toErpPayload(a)),
    toNormalized(OrderTransform.toErpPayload(b))
  )

// Promotions resolve from variable_values, so the rest still needs a round trip
const isSameOrder = (a: Order, b: Order) =>
  isEqual(toNormalized(a), toNormalized(b))

const isRecord = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === 'object' && !Array.isArray(value)

const collectChangedPaths = (
  a: unknown,
  b: unknown,
  path: string
): string[] => {
  if (isEqual(a, b)) {
    return []
  }
  if (!isRecord(a) || !isRecord(b)) {
    return [path || '.']
  }
  const keys = new Set([...Object.keys(a), ...Object.keys(b)])
  return [...keys].flatMap((key) =>
    collectChangedPaths(a[key], b[key], path ? `${path}.${key}` : key)
  )
}

// Names the differing fields, the ERP logs cannot show them
const getChangedPaths = (a: unknown, b: unknown) =>
  collectChangedPaths(toNormalized(a), toNormalized(b), '')

export const OrderCompare = {
  isSameOrder,
  isSameErpOrder,
  getChangedPaths,
}
